import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "member-fig" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "mb-0 me-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fa fa-volume-mute me-1" }, null, -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-volume-up me-1" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-info-circle",
  style: {"cursor":"pointer"},
  title: "More Info"
}, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "member-tooltip bg-light border p-2 mt-1 rounded shadow-sm"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createVNode("strong", null, "Valid Till:", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Never Expire ")
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createVNode("strong", null, "Valid Till:", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("strong", null, "Conversation History From:", -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "inline-items align-middle mt-2"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments mr-1" }, null, -1)
const _hoisted_19 = { class: "remove-btn mt-0 mx-3" }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_21 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_22 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "removemember",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_23 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_24 = {
  key: 0,
  class: "modal-content h-auto"
}
const _hoisted_25 = { class: "modal-header" }
const _hoisted_26 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_28 = { class: "modal-body" }
const _hoisted_29 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, " Removing user will:")
], -1)
const _hoisted_30 = { class: "block-list" }
const _hoisted_31 = { class: "modal-footer" }
const _hoisted_32 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_33 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "muteMember",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_34 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_35 = {
  key: 0,
  class: "modal-content h-auto"
}
const _hoisted_36 = { class: "modal-header" }
const _hoisted_37 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_38 = {
  key: 1,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_40 = { class: "modal-body" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createVNode("strong", null, " Once muted, you won't receive notifications but can still use the channel fully. ", -1)
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createVNode("strong", null, " Unmuting the channel resumes notifications while all activities remain accessible. ", -1)
const _hoisted_45 = { class: "modal-footer" }
const _hoisted_46 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_47 = {
  class: "modal fade",
  id: "modifyMemberDateByChannel",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_48 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_49 = { class: "modal-content" }
const _hoisted_50 = { class: "modal-header border-0" }
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_52 = { class: "modal-body" }
const _hoisted_53 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Include Conversation History ?", -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Choose whether the listed user can see past messages and files once they're added to the conversation. ", -1)
const _hoisted_55 = { class: "form-group mt-3" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" From Invitation Accepted ")
const _hoisted_57 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" From Today ")
const _hoisted_59 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" From The Beginning ")
const _hoisted_61 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Custom ")
const _hoisted_63 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_64 = {
  key: 0,
  class: "row"
}
const _hoisted_65 = { class: "col-md-3" }
const _hoisted_66 = { class: "form-group" }
const _hoisted_67 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_date_picker = _resolveComponent("v-date-picker")

  return (_openBlock(), _createBlock("div", null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.memberList, (member, memberIndex) => {
      return (_openBlock(), _createBlock("div", {
        class: "member-list",
        key: memberIndex
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", {
            class: member.user.online_status === 'online'
          ? 'status-icon'
          : 'status-icon gray-icon'
          
          }, null, 2),
          (member.user.image)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: member.user.image,
                alt: member.user.email,
                title: member.user.email
              }, null, 8, ["src", "alt", "title"]))
            : (_openBlock(), _createBlock("img", {
                key: 1,
                src: _ctx.state.data.imageBaseUrl
          ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
          : 'img/no-user.jpg',
                alt: member.user.email,
                title: member.user.email
              }, null, 8, ["src", "alt", "title"]))
        ]),
        _createVNode("div", _hoisted_2, [
          _createVNode("h5", _hoisted_3, _toDisplayString(member.user.full_name), 1),
          (member.is_mute == 0 && member.user.id === _ctx.currentUserId && _ctx.showEditor)
            ? (_openBlock(), _createBlock("span", _hoisted_4, [
                (_ctx.channelStatus)
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      class: "btn default-btn outline btn-sm",
                      title: "Mute",
                      href: "javascript:void(0)",
                      "data-toggle": "modal",
                      onClick: ($event: any) => (_ctx.muteMember(member))
                    }, [
                      _hoisted_5
                    ], 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (member.is_mute == 1 && member.user.id === _ctx.currentUserId && _ctx.showEditor)
            ? (_openBlock(), _createBlock("span", _hoisted_6, [
                (_ctx.channelStatus)
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      class: "btn default-btn outline btn-sm",
                      title: "Unmute",
                      href: "javascript:void(0)",
                      "data-toggle": "modal",
                      onClick: ($event: any) => (_ctx.muteMember(member))
                    }, [
                      _hoisted_7
                    ], 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (member.invitation)
            ? (_openBlock(), _createBlock("span", {
                key: 2,
                class: "info-icon",
                onMouseenter: ($event: any) => (_ctx.activeTooltipIndex = memberIndex),
                onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTooltipIndex = null))
              }, [
                _hoisted_8
              ], 40, ["onMouseenter"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.activeTooltipIndex === memberIndex)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              (member.invitation?.completed_date && member.invitation?.validity === 0)
                ? (_openBlock(), _createBlock("p", _hoisted_10, [
                    _hoisted_11,
                    _hoisted_12
                  ]))
                : (member.invitation?.completed_date && member.invitation?.validity)
                  ? (_openBlock(), _createBlock("p", _hoisted_13, [
                      _hoisted_14,
                      _createTextVNode(" " + _toDisplayString(_ctx.calculateValidTill(member.invitation.completed_date, member.invitation.validity)), 1)
                    ]))
                  : _createCommentVNode("", true),
              _createVNode("p", null, [
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_ctx.formatDate(member.invitation?.message_from_date) ?? 'N/A'), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (member.user.id != _ctx.ownerId)
          ? (_openBlock(), _createBlock("p", _hoisted_16, _toDisplayString(member.created_info), 1))
          : _createCommentVNode("", true),
        (_ctx.showEditor)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode("ul", null, [
                _createVNode("li", null, [
                  (_ctx.state.email != member.user.email &&
              _ctx.channelStatus &&
              _ctx.channelType != 2
            )
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        "data-toggle": "modal",
                        title: "private chat",
                        onClick: ($event: any) => (_ctx.privateChat(member))
                      }, [
                        _hoisted_18
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("li", null, [
                  _createVNode("div", _hoisted_19, [
                    (_ctx.channelStatus &&
                member.isChangeRole &&
                member.user.id != _ctx.ownerId &&
                _ctx.channelType != 2
              )
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          class: "btn-sm",
                          href: "javascript:void(0)",
                          "data-toggle": "modal",
                          onClick: ($event: any) => (_ctx.selectedMember(member))
                        }, [
                          _hoisted_20
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createVNode("div", _hoisted_21, [
      _createVNode("div", _hoisted_22, [
        _createVNode("div", _hoisted_23, [
          (_ctx.state.selectedMemberForRemoval.user)
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode("h5", _hoisted_26, " Remove " + _toDisplayString(_ctx.state.selectedMemberForRemoval.user.full_name) + " ? ", 1),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideRemoveMemberModal && _ctx.hideRemoveMemberModal(...args))),
                    "aria-label": "Close"
                  }, [
                    _hoisted_27
                  ])
                ]),
                _createVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode("div", _hoisted_30, [
                    _createVNode("ul", null, [
                      _createVNode("li", null, _toDisplayString(_ctx.state.selectedMemberForRemoval.user.full_name) + " will be removed them from this channel. ", 1),
                      _createVNode("li", null, _toDisplayString(_ctx.state.selectedMemberForRemoval.user.full_name) + " will not be able to perform any activity in this channel. ", 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn btn-sm",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideRemoveMemberModal && _ctx.hideRemoveMemberModal(...args)))
                  }, " Cancel "),
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn btn-sm",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.removeSelectedMember && _ctx.removeSelectedMember(...args)))
                  }, _toDisplayString(_ctx.state.postLoading.removeSelectedMember
                    ? "Removing..."
                    : "Yes,remove user."), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_32, [
      _createVNode("div", _hoisted_33, [
        _createVNode("div", _hoisted_34, [
          (_ctx.state.selectedMemberForRemoval.user)
            ? (_openBlock(), _createBlock("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  (_ctx.state.selectedMemberForRemoval.is_mute == 0)
                    ? (_openBlock(), _createBlock("h5", _hoisted_37, " Mute " + _toDisplayString(_ctx.state.selectedMemberForRemoval.user.full_name) + " ? ", 1))
                    : (_openBlock(), _createBlock("h5", _hoisted_38, " Unmute " + _toDisplayString(_ctx.state.selectedMemberForRemoval.user.full_name) + " ? ", 1)),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideMuteMemberModal && _ctx.hideMuteMemberModal(...args))),
                    "aria-label": "Close"
                  }, [
                    _hoisted_39
                  ])
                ]),
                _createVNode("div", _hoisted_40, [
                  (_ctx.state.selectedMemberForRemoval.is_mute == 0)
                    ? (_openBlock(), _createBlock("p", _hoisted_41, [
                        _hoisted_42
                      ]))
                    : (_openBlock(), _createBlock("p", _hoisted_43, [
                        _hoisted_44
                      ]))
                ]),
                _createVNode("div", _hoisted_45, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn btn-sm",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideMuteMemberModal && _ctx.hideMuteMemberModal(...args)))
                  }, " Cancel "),
                  (_ctx.state.selectedMemberForRemoval.is_mute == 0)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn default-btn btn-sm",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.muteChannelMember && _ctx.muteChannelMember(...args)))
                      }, _toDisplayString(_ctx.state.postLoading.removeSelectedMember
                    ? "Mute..."
                    : "Yes,mute."), 1))
                    : (_openBlock(), _createBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn default-btn",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.muteChannelMember && _ctx.muteChannelMember(...args)))
                      }, _toDisplayString(_ctx.state.postLoading.removeSelectedMember
                    ? "unmute..."
                    : "Yes,unmute."), 1))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_46, [
      _createVNode("div", _hoisted_47, [
        _createVNode("div", _hoisted_48, [
          _createVNode("div", _hoisted_49, [
            _createVNode("div", _hoisted_50, [
              _createVNode("button", {
                type: "button",
                class: "close",
                "aria-label": "Close",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hideHistoryMember && _ctx.hideHistoryMember(...args)))
              }, [
                _hoisted_51
              ])
            ]),
            _createVNode("div", _hoisted_52, [
              _hoisted_53,
              _hoisted_54,
              _createVNode("div", _hoisted_55, [
                _createVNode("label", null, [
                  _withDirectives(_createVNode("input", {
                    type: "radio",
                    name: "fruit",
                    value: "1",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedValueForPending = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.selectedValueForPending]
                  ]),
                  _hoisted_56
                ]),
                _hoisted_57,
                _createVNode("label", null, [
                  _withDirectives(_createVNode("input", {
                    type: "radio",
                    name: "fruit",
                    value: "2",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedValueForPending = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.selectedValueForPending]
                  ]),
                  _hoisted_58
                ]),
                _hoisted_59,
                _createVNode("label", null, [
                  _withDirectives(_createVNode("input", {
                    type: "radio",
                    name: "fruit",
                    value: "3",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedValueForPending = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.selectedValueForPending]
                  ]),
                  _hoisted_60
                ]),
                _hoisted_61,
                _createVNode("label", null, [
                  _withDirectives(_createVNode("input", {
                    type: "radio",
                    name: "fruit",
                    value: "4",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectedValueForPending = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.selectedValueForPending]
                  ]),
                  _hoisted_62
                ]),
                _hoisted_63
              ]),
              (_ctx.selectedValueForPending === '4')
                ? (_openBlock(), _createBlock("div", _hoisted_64, [
                    _createVNode("div", _hoisted_65, [
                      _createVNode("div", _hoisted_66, [
                        _createVNode(_component_v_date_picker, {
                          modelValue: _ctx.selectedDateForMember,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectedDateForMember = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_67, [
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.hideHistoryMember && _ctx.hideHistoryMember(...args)))
              }, " Cancel "),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.modifyHistoryDateForMember && _ctx.modifyHistoryDateForMember(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.deletePendingInvitation
                    ? "Loading..."
                    : "Modify"), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}